import _typeof from "@babel/runtime/helpers/typeof";

/**
 * @file isClient
 * @author yuzong(yuzong@tencent.com)
 */
export function isClient() {
  return (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object';
}